import { Action } from 'redux'
import { ICreateReservationFormValues } from '../../../containers/Form/CreateReservation/CreateReservation'
import { EventActions } from '../../../reducers/bookingCalendar/actionNames'
import { IEvent } from '../../../models/Event'

const requestUpdateEvent = (
  event: ICreateReservationFormValues,
  eventId = null,
  toastOnSyncNeeded = false,
): IRequestUpdateEvent => ({
  event,
  eventId,
  toastOnSyncNeeded,
  type: EventActions.RequestUpdateEvent,
})

export interface IRequestUpdateEvent
  extends Action<EventActions.RequestUpdateEvent> {
  eventId?: number
  event: ICreateReservationFormValues
  toastOnSyncNeeded?: boolean
}

const eventWasUpdated = (event: IEvent, putToDb = true): IEventWasUpdated => ({
  event,
  putToDb,
  type: EventActions.EventWasUpdated,
})

export interface IEventWasUpdated extends Action<EventActions.EventWasUpdated> {
  event: IEvent
  putToDb?: boolean
}

export { eventWasUpdated }
export default requestUpdateEvent
